import React from 'react';
import { EditableComponent } from '@adobe/aem-react-editable-components';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { OHighlight as OHighlightComp } from '@marriott/mi-web-ui-kit';
import clsx from 'clsx';

const TEST_ID = 'designsystem-components-OHighlight';

export const OHighlightConfig = {
  emptyLabel: 'OHighlight',
  isEmpty: () => true,
  resourceType: `${process.env['NEXT_PUBLIC_AEM_SITE']}/components/content/o-highlight`,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const OHighlight = (props: any) => {
  const model = props.model || {};
  const { styleclass, componentId } = model;

  return (
    <div data-testid={TEST_ID} data-component-name={`o-${TEST_ID}`} id={componentId} className={clsx(styleclass)}>
      <EditableComponent config={OHighlightConfig} {...props}>
        <OHighlightComp {...props} />
      </EditableComponent>
    </div>
  );
};
